import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';

import styles from '../styles/Modal.module.scss';

export const useModal = () => {
    const [isModalShowing, setIsModalShowing] = useState(false);

    function toggleModal() {
        setIsModalShowing(!isModalShowing);
    }

    return {
        isModalShowing,
        toggleModal,
    };
};

interface ModalProps {
    isModalShowing: boolean;
    hide?: () => void;
    children: React.ReactNode;
}

const Modal = ({ isModalShowing, hide, children }: ModalProps) => {
    const ref = useRef<Element>();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        ref.current = document.querySelector('#modal') ?? document.body;
        setMounted(true);
    }, []);

    useEffect(() => {
        // prevent the background from scrolling while viewing the modal.
        if (isModalShowing) {
            document.body.style.position = 'fixed';
            document.body.style.overflowY = 'scroll';
        } else {
            document.body.style.position = '';
            document.body.style.overflowY = '';
        }
    }, [isModalShowing]);

    return mounted
        ? ReactDOM.createPortal(
              <div
                  className={
                      isModalShowing ? styles.showModal : styles.hideModal
                  }
              >
                  <div onClick={hide} className={styles.overlay}>
                      <div
                          className={cx('rideReportContainer', styles.modal)}
                          onClick={e => e.stopPropagation()}
                          aria-modal
                          aria-hidden
                          tabIndex={-1}
                          role="dialog"
                      >
                          {children}
                      </div>
                  </div>
              </div>,
              ref.current as Element
          )
        : null;
};

export default Modal;
